// 路由切换时的滚动规则。默认回到顶部；页面在 meta 里声明 keepScrollOnQuery 后，
// 同一页只改 query（手机图库开关查看弹窗）不动滚动位置，否则一开弹窗列表就跳回顶部。
export function resolveScroll(to, from) {
  const keep = to.path === from.path && to.meta && to.meta.keepScrollOnQuery
  return keep ? false : { y: 0 }
}
